/**
 * Read more about middleware here:
 * http://redux.js.org/docs/advanced/Middleware.html
 *
 */
import { applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';

import promo from './promo';
import braze from './braze';
import session from './session';
import fetchMiddleware from './fetch';
import dialog from './dialog';
import nudata from './nudata';
import recaptcha from './recaptcha';
import segmentMiddleware from './segment';

const createMiddleware = ({ history, analytics }) => {
	const middleware = [
		routerMiddleware(history),
		nudata,
		promo,
		recaptcha,
		session,
		dialog,
		braze,
		fetchMiddleware,
		segmentMiddleware(analytics),
	];
	return composeWithDevTools(applyMiddleware(...middleware));
};

export default createMiddleware;
